import { stringify } from 'querystring';

import type { User } from '@ms/yammer-data/dist/state/types';

import type { GetBaseUrlProps } from '../location/getBaseUrl';
import { getBaseUrl } from '../location/getBaseUrl';

type AchievementsPage = (userId: User['id']) => string;
export const achievementsPage: AchievementsPage = (userId) => `/achievements/${userId}`;

type AchievementsPageUrl = (userId: User['id'], host: GetBaseUrlProps['host']) => string;
export const achievementsPageUrl: AchievementsPageUrl = (userId, host) => {
  const baseUrl = getBaseUrl({ host });

  return `${baseUrl}${achievementsPage(userId)}`;
};

export const achievementTypeQueryKey = 'type';
export const achievementLevelQueryKey = 'level';
export const achievementPathQueryKey = 'path';
export const achievementCountQueryKey = 'count';

interface AchievementPageParameters {
  [key: string]: string;
  readonly [achievementTypeQueryKey]: string;
  readonly [achievementLevelQueryKey]: string;
  readonly [achievementPathQueryKey]: string;
  readonly [achievementCountQueryKey]: string;
}
export const achievementsPageWithParameters = (userId: User['id'], parameters: AchievementPageParameters) => {
  const achievementUrlPath = achievementsPage(userId);
  const achievementParams = stringify(parameters);

  return `${achievementUrlPath}?${achievementParams}`;
};
